<template>
  <HeaderBlock msg="HeaderBlock" />
  <NavBlock msg="NavBlock" />
  <!-- title -->
  <div class="page-wrapper">
    <div class="page-header d-print-none">
      <div class="container-xl">
        <div class="row g-2 align-items-center">
          <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle"></div>
            <h2 class="page-title">
            </h2>
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
    <div class="page-body">
      <div class="container container-tight py-4">
        <h2 class="mb-3">删除账户申请</h2>
        <p>申请之后，我们将删除您所有的数据。</p>
        <p>删除时间可能是1分钟内，也可能是5个工作日内。</p>
        <p>以后您可以继续使用此账户注册，这将是全新的账户。</p>
        <p class="text-danger">
          ⚠️请注意，一旦申请，数据将无法恢复。
        </p>
        <ul class="list-unstyled space-y">
          <li class="row g-2">
            <span class="col-auto">
              <i class="fa fa-close"></i>
            </span>
            <span class="col">
              <strong class="d-block">删除设备数据</strong>
              <span class="d-block text-secondary">删除所有设备数据以及关联的日志数据。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto">
              <i class="fa fa-close"></i>
            </span>
            <span class="col">
              <strong class="d-block">删除推送数据</strong>
              <span class="d-block text-secondary">删除已推送的所有数据。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto">
              <i class="fa fa-close"></i>
            </span>
            <span class="col">
              <strong class="d-block">删除账户</strong>
              <span class="d-block text-secondary">删除账户以及账户关联的所有数据。</span>
            </span>
          </li>
        </ul>
        <div class="my-4">
          <a class="btn btn-danger w-100" data-bs-toggle="modal" data-bs-target="#modal-small">
            是的，删除我所有的数据
          </a>
        </div>
        <p class="text-secondary">
        </p>
      </div>
      <div class="modal modal-blur fade" id="modal-small" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div class="modal-title">您确定要删除吗?</div>
              <div>如果您确定将会销毁您所有的数据.</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn  me-auto btn-danger" data-bs-dismiss="modal">取消</button>
              <button type="button" class="btn btn-link link-secondary" data-bs-dismiss="modal"
                @click="destroyAccount">是的，我确定删除</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <FooterBlock msg="FooterBlock" />
</template>

<script>
import HeaderBlock from '../components/HeaderBlock.vue'
import FooterBlock from '../components/FooterBlock.vue'
import NavBlock from '../components/NavBlock.vue'
import { global } from '../global.js'
export default {
  name: 'DestroyAccountPage',
  components: {
    HeaderBlock,
    FooterBlock,
    NavBlock,
  },
  data() {
    return {
      global: global,
    };
  },
  methods: {
    destroyAccount: function () {
      global.postData("user/destory_account", {}, { token: true, sign: true })
        .then(data => {
          global.showTips(data.msg);
          if (data.code == 200) {
            localStorage.removeItem("userinfo");
            this.$router.push('/signin')
          }
        });
    },
  },
}
</script>